<template>
    <div id="app">
        <router-view />
        <!-- 全局唯一的预览 iframe -->
        <GlobalPreviewIframe />
        <FloatingBall />
    </div>
</template>

<script>
import GlobalPreviewIframe from "@/components/GlobalPreviewIframe";
import FloatingBall from "@/components/FloatingBall";
export default {
    name: "App",
    components: { GlobalPreviewIframe, FloatingBall },
};
</script>

<style>
</style>
